import script from "./HandoverConfirmationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HandoverConfirmationModal.vue?vue&type=script&setup=true&lang=ts"

import "./HandoverConfirmationModal.vue?vue&type=style&index=0&id=2ba60386&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba60386"]])

export default __exports__